import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
// import Icon from "module-common/Icon";
import { Menu, Dropdown, Button, Icon, message } from "antd";

export default class SelectBoxSendWhatsapp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "Send to Livechat"
    };
  }

  handleMenuClick = e => {
    if (e.key == "whatsapp") {
      this.setState({
        selected: "Send to Whatsapp"
      });
    } else if (e.key == "livechat") {
      this.setState({
        selected: "Send to Livechat"
      });
    }
  };

  onChangeState = () => {
    const { selected } = this.state;

    if (selected == "Send to Whatsapp") {
      this.props.onClick("whatsapp");
    } else if (selected == "Send to Livechat") {
      this.props.onClick("livechat");
    }
  };

  render() {
    const menu = (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key="whatsapp">Send to Whatsapp</Menu.Item>
        <Menu.Item key="livechat">Send to Livechat</Menu.Item>
      </Menu>
    );

    return (
      <Wrapper>
        <SendButtonWrapper>
          <SendButton onClick={this.onChangeState}>
            {this.state.selected}
          </SendButton>
        </SendButtonWrapper>
        <DropDownWrapper>
          <Dropdown overlay={menu}>
            <Button
              style={{
                "background-color": "transparent",
                border: "none",
                "border-top-right": "30px",
                "border-bottom-right": "30px"
              }}
            >
              <Icon type="down" style={{ color: "white" }} />
            </Button>
          </Dropdown>
        </DropDownWrapper>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background: #338dca;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
`;

const SendButtonWrapper = styled.div`
  display: flex;
  flex-grow: 2;
  align-content: center;
  margin-left: 9px;
  &:hover {
    opacity: 0.5;
  }
  height: 100%;
`;

const SendButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  &:focus : {
    opacity: 0.5;
  }
`;
const DropDownWrapper = styled.div`
  display: flex;
  border-left: 1px solid white;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  margin-left: 5px;
`;
const IconWrapper = styled.div`
  /* background-color: ${props => props.theme.blueButton}; */
  background-color: ${props =>
    props.disabled ? "#ddd" : props.theme.blueButton};
  border-radius: 0 3px 3px 0;
  padding: 0 4px;
  flex:1;
`;



// WEBPACK FOOTER //
// ./src/module-common/SelectBoxSendWhatsapp.js